export const TAB_SUGGESTIONS = 'suggestions';
export const TAB_NETWORK = 'network';
export const TAB_CHATS = 'chats';

export const TAB_THINK_CHATS = 'think-chats';
export const TAB_THINK_TANKS = 'think-tanks';

export const TAB_CHAT = 'chat';
export const TAB_COLLABORATE = 'collaborate';
export const TAB_TOOLS = 'tools';
export const TAB_USERS = 'users';



// WEBPACK FOOTER //
// ./src/constants/others.js